import { ProtocolIcon } from './chunk-IVKBUXNO.js';
import { ProtocolBadge } from './chunk-H6QQORH4.js';
import { pickField, ProtocolValue, SectionCard, FactGrid, ProtocolParamList } from './chunk-E4NIZZY2.js';
import { ShieldAlert, KeyRound } from 'lucide-react';
import { jsx, jsxs } from 'react/jsx-runtime';

// src/protocols/gnosis_safe/labels.ts
var GNOSIS_SAFE = {
  protocolId: "gnosis_safe",
  displayName: "Gnosis Safe",
  docs: "https://docs.safe.global"
};
var GNOSIS_SAFE_COMPONENTS = {
  moduleTransaction: "SafeModuleTransaction"
};
var GNOSIS_SAFE_EVENTS = {
  moduleTransaction: "SafeModuleTransaction"
};
var GNOSIS_SAFE_FIELDS = {
  module: "module",
  to: "to",
  value: "value",
  operation: "operation"
};
var GNOSIS_SAFE_LABELS = {
  safe: "Safe",
  module: "Executed by module",
  target: "Called",
  value: "Value",
  noSignatures: "No owner signatures",
  delegateCall: "delegatecall"
};
var SAFE_OPERATION_DELEGATECALL = "1";
var NOTE_CHIP = "inline-flex items-center gap-1 rounded-full border border-border/60 bg-muted/40 px-2 py-0.5 text-2xs font-medium";
var WARN_CHIP = "inline-flex items-center gap-1 rounded-full border border-warning/40 bg-warning/10 px-2 py-0.5 text-2xs font-medium";
function SafeModuleTransaction({
  event,
  hint,
  chain,
  renderAddress
}) {
  const pid = hint.protocolId ?? GNOSIS_SAFE.protocolId;
  const module = pickField(event.params, GNOSIS_SAFE_FIELDS.module);
  const target = pickField(event.params, GNOSIS_SAFE_FIELDS.to);
  const value = pickField(event.params, GNOSIS_SAFE_FIELDS.value);
  const operation = pickField(event.params, GNOSIS_SAFE_FIELDS.operation);
  const isDelegate = String(operation ?? "") === SAFE_OPERATION_DELEGATECALL;
  const address = (v) => typeof v === "string" && renderAddress ? renderAddress(v, { chain }) : /* @__PURE__ */ jsx(ProtocolValue, { value: v });
  const facts = [
    // The emitter is the Safe itself — a per-multisig proxy, so this address is
    // the account whose funds moved.
    { label: GNOSIS_SAFE_LABELS.safe, value: address(event.address), when: event.address },
    { label: GNOSIS_SAFE_LABELS.module, value: address(module), when: module },
    { label: GNOSIS_SAFE_LABELS.target, value: address(target), when: target },
    { label: GNOSIS_SAFE_LABELS.value, value: /* @__PURE__ */ jsx(ProtocolValue, { value }), when: value != null }
  ];
  return /* @__PURE__ */ jsxs(
    SectionCard,
    {
      title: /* @__PURE__ */ jsxs("span", { className: "inline-flex items-center gap-2", children: [
        /* @__PURE__ */ jsx(ProtocolIcon, { protocolId: pid, icon: KeyRound }),
        /* @__PURE__ */ jsx("span", { className: "text-sm font-semibold", children: hint.label ?? "Safe module transaction" })
      ] }),
      protocolId: pid,
      meta: /* @__PURE__ */ jsxs("span", { className: "inline-flex items-center gap-2", children: [
        /* @__PURE__ */ jsx(
          "span",
          {
            className: NOTE_CHIP,
            title: "A module acts on the Safe's own authority \u2014 this moved without any owner signature or threshold.",
            children: GNOSIS_SAFE_LABELS.noSignatures
          }
        ),
        isDelegate && /* @__PURE__ */ jsxs(
          "span",
          {
            className: WARN_CHIP,
            title: "A delegatecall runs the target's code inside the Safe's own storage, so it can change the owner set.",
            children: [
              /* @__PURE__ */ jsx(ShieldAlert, { className: "size-3", "aria-hidden": true }),
              GNOSIS_SAFE_LABELS.delegateCall
            ]
          }
        ),
        /* @__PURE__ */ jsx(ProtocolBadge, { protocolId: pid })
      ] }),
      children: [
        /* @__PURE__ */ jsx(FactGrid, { facts }),
        /* @__PURE__ */ jsxs("details", { className: "mt-3 min-w-0", children: [
          /* @__PURE__ */ jsx("summary", { className: "cursor-pointer text-xs text-muted-foreground hover:text-foreground", children: "All event fields" }),
          /* @__PURE__ */ jsx("div", { className: "pt-2", children: /* @__PURE__ */ jsx(ProtocolParamList, { params: event.params, emptyLabel: "No decoded fields" }) })
        ] })
      ]
    }
  );
}

// src/protocols/gnosis_safe/index.ts
var PID = GNOSIS_SAFE.protocolId;
var C = GNOSIS_SAFE_COMPONENTS;
var GNOSIS_SAFE_HINTS = {
  valueHints: [],
  callHints: [],
  eventHints: [
    {
      protocolId: PID,
      event: GNOSIS_SAFE_EVENTS.moduleTransaction,
      component: C.moduleTransaction,
      summaryFields: []
    }
  ]
};
function registerGnosisSafe(registry) {
  registry.registerEvent(C.moduleTransaction, SafeModuleTransaction);
  registry.registerHints(GNOSIS_SAFE_HINTS);
  return registry;
}

export { GNOSIS_SAFE, GNOSIS_SAFE_COMPONENTS, GNOSIS_SAFE_EVENTS, GNOSIS_SAFE_FIELDS, GNOSIS_SAFE_HINTS, GNOSIS_SAFE_LABELS, SafeModuleTransaction, registerGnosisSafe };
//# sourceMappingURL=chunk-EBKUN2JT.js.map
//# sourceMappingURL=chunk-EBKUN2JT.js.map